export interface Video {
  id: string;
  title: string;
  description: string;
  category: string;
  thumbnail: string;
  duration: string;
  quality: string;
  views: number;
  rating: number;
  year: number;
  tags: string[];
  featured: boolean;
  isNew: boolean;
  content: string;
  director: string;
  actors: string[];
}

export const categories = [
  { id: 'all', name: '全部', icon: 'ri-apps-line' },
  { id: 'action', name: '动作片', icon: 'ri-fire-line' },
  { id: 'comedy', name: '喜剧片', icon: 'ri-emotion-laugh-line' },
  { id: 'romance', name: '爱情片', icon: 'ri-heart-line' },
  { id: 'scifi', name: '科幻片', icon: 'ri-rocket-line' },
  { id: 'horror', name: '恐怖片', icon: 'ri-ghost-line' },
  { id: 'anime', name: '动漫', icon: 'ri-movie-line' },
  { id: 'drama', name: '剧情片', icon: 'ri-film-line' },
  { id: 'documentary', name: '纪录片', icon: 'ri-camera-line' },
];

export const videos: Video[] = [
  {
    id: 'v001',
    title: '流浪地球3',
    description: '太阳急速衰老膨胀，人类面临灭顶之灾。为了生存，人类启动"流浪地球"计划，倾尽所有建造一万座行星发动机，推动地球离开太阳系，开启长达2500年的星际流浪之旅。',
    category: 'scifi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20scene%20with%20Earth%20moving%20through%20space%2C%20massive%20engines%2C%20dramatic%20lighting%2C%20cinematic%20style%20with%20warm%20orange%20and%20deep%20space%20contrast%2C%20high%20quality%20film%20poster%20aesthetic&width=800&height=450&seq=movie-scifi-01&orientation=landscape',
    duration: '148分钟',
    quality: '1080P',
    views: 2850000,
    rating: 9.2,
    year: 2025,
    tags: ['科幻', '灾难', '国产'],
    featured: true,
    isNew: true,
    content: '《流浪地球3》是由郭帆执导，吴京、刘德华等主演的科幻灾难电影。影片延续前作故事线，人类在流浪旅程中面临新的危机与挑战。太阳氦闪危机加剧，地球表面环境持续恶化，人类在地下城中的生存空间不断被压缩。联合政府面临着艰难的抉择——是继续前行，还是寻找新的希望。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢'],
  },
  {
    id: 'v002',
    title: '长安三万里',
    description: '以盛唐为背景，讲述高适与李白之间跨越数十年的深厚友谊，展现了大唐盛世下的诗人命运与家国情怀。',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20ancient%20Tang%20dynasty%20animated%20film%20scene%2C%20poets%20in%20traditional%20robes%2C%20golden%20palace%20background%2C%20warm%20evening%20light%2C%20artistic%20cinematic%20composition&width=800&height=450&seq=movie-anime-01&orientation=landscape',
    duration: '168分钟',
    quality: '4K',
    views: 4200000,
    rating: 9.5,
    year: 2024,
    tags: ['动画', '历史', '国产'],
    featured: true,
    isNew: false,
    content: '《长安三万里》是一部以盛唐为背景的动画历史电影。影片通过高适的视角，回顾了他与李白从青年到暮年的深厚友谊，展现了唐诗的辉煌与大唐盛世的风貌。片中融入了大量经典唐诗，让观众在欣赏动画的同时感受中华诗词文化的魅力。',
    director: '追光动画',
    actors: ['杨天翔', '凌振赫', '吴俊全'],
  },
  {
    id: 'v003',
    title: '消失的她',
    description: '何非的妻子在海外度假时离奇失踪，当他报案后，一个陌生女人突然出现声称自己就是他的妻子，真相逐渐浮出水面。',
    category: 'drama',
    thumbnail: 'https://readdy.ai/api/search-image?query=Suspenseful%20thriller%20film%20scene%2C%20tropical%20beach%20at%20night%2C%20mysterious%20atmosphere%2C%20dim%20warm%20lighting%2C%20cinematic%20noir%20style%20with%20deep%20shadows&width=800&height=450&seq=movie-drama-01&orientation=landscape',
    duration: '122分钟',
    quality: '1080P',
    views: 5600000,
    rating: 8.8,
    year: 2024,
    tags: ['悬疑', '犯罪', '剧情'],
    featured: true,
    isNew: false,
    content: '《消失的她》是一部悬疑犯罪电影。何非与妻子李木子在东南亚度假，妻子却在一夜之间消失得无影无踪。当地警方不愿立案调查，何非几近崩溃。就在这时，一个自称是李木子的陌生女人出现在他面前，所有人都相信她就是李木子——除了何非自己。',
    director: '崔睿',
    actors: ['朱一龙', '倪妮', '文咏珊'],
  },
  {
    id: 'v004',
    title: '飞驰人生3',
    description: '曾经的赛车冠军张驰重返赛场，面对新一代年轻车手的挑战，他用行动证明年龄只是一个数字。',
    category: 'comedy',
    thumbnail: 'https://readdy.ai/api/search-image?query=Car%20racing%20movie%20scene%20on%20desert%20track%2C%20sports%20cars%20speeding%2C%20dust%20trails%2C%20warm%20sunset%20golden%20hour%20lighting%2C%20cinematic%20action%20shot&width=800&height=450&seq=movie-comedy-01&orientation=landscape',
    duration: '135分钟',
    quality: '4K',
    views: 3100000,
    rating: 8.5,
    year: 2025,
    tags: ['喜剧', '赛车', '动作'],
    featured: false,
    isNew: true,
    content: '《飞驰人生3》延续了系列的一贯风格，赛车手张驰在经历低谷后再次出发。这一次他不仅是车手，更是导师，带领年轻一代车手征战国际赛场。影片充满速度与激情，同时也饱含对梦想的执着追求。',
    director: '韩寒',
    actors: ['沈腾', '尹正', '范丞丞'],
  },
  {
    id: 'v005',
    title: '美人鱼2',
    description: '刘轩在经历企业转型后，再次面临来自海洋的全新危机，他与珊珊的爱情也迎来了新的考验。',
    category: 'comedy',
    thumbnail: 'https://readdy.ai/api/search-image?query=Underwater%20fantasy%20comedy%20film%20scene%2C%20colorful%20coral%20reef%20ocean%20background%2C%20whimsical%20atmosphere%2C%20bright%20warm%20tones%2C%20cinematic%20fantasy%20aesthetic&width=800&height=450&seq=movie-comedy-02&orientation=landscape',
    duration: '118分钟',
    quality: '1080P',
    views: 1800000,
    rating: 7.9,
    year: 2025,
    tags: ['喜剧', '奇幻', '爱情'],
    featured: false,
    isNew: true,
    content: '《美人鱼2》是周星驰导演的奇幻喜剧续作。故事发生在第一部之后的数年，刘轩的公司转型成功，但他的新发明却意外引来了来自海洋深处的全新威胁。为了保护海洋和心爱的人，刘轩和珊珊再次联手对抗新的挑战。',
    director: '周星驰',
    actors: ['艾伦', '林允', '邓超'],
  },
  {
    id: 'v006',
    title: '封神第二部',
    description: '殷商末年，纣王暴虐无道，姬发率领八百诸侯举兵伐纣，一场关乎人神命运的史诗之战即将展开。',
    category: 'action',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mythological%20war%20scene%2C%20warriors%20in%20armor%20battling%2C%20epic%20scale%2C%20dramatic%20sky%20with%20warm%20golden%20light%2C%20cinematic%20fantasy%20battle&width=800&height=450&seq=movie-action-01&orientation=landscape',
    duration: '156分钟',
    quality: '4K',
    views: 4800000,
    rating: 9.0,
    year: 2025,
    tags: ['动作', '奇幻', '史诗'],
    featured: true,
    isNew: true,
    content: '《封神第二部》承接前作，殷郊在昆仑山获得重生，姬发返回西岐后发现父亲已被囚禁。纣王派出各路神仙征讨西岐，大战一触即发。闻仲率领魔家四将、邓婵玉等大军压境，西岐面临前所未有的危机。',
    director: '乌尔善',
    actors: ['费翔', '黄渤', '于适'],
  },
  {
    id: 'v007',
    title: '熊出没·重启未来',
    description: '熊大、熊二和光头强意外穿越到未来世界，发现自己成为拯救未来的关键人物。',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20animated%20forest%20scene%20with%20bears%20and%20technology%2C%20colorful%20neon%20lights%20in%20trees%2C%20family%20friendly%20cartoon%20style%2C%20warm%20and%20vibrant%20atmosphere&width=800&height=450&seq=movie-anime-02&orientation=landscape',
    duration: '105分钟',
    quality: '1080P',
    views: 2200000,
    rating: 8.3,
    year: 2025,
    tags: ['动画', '科幻', '家庭'],
    featured: false,
    isNew: true,
    content: '《熊出没·重启未来》讲述了熊大、熊二和光头强被一个神秘装置带到一百年后的未来世界。在未来的森林中，他们发现自然环境已经遭到了严重破坏。为了修复时间线，三个伙伴必须齐心协力，在未来的世界中完成一项不可能的任务。',
    director: '丁亮',
    actors: ['张伟', '谭笑', '张秉君'],
  },
  {
    id: 'v008',
    title: '热辣滚烫',
    description: '一个胖女孩通过拳击找到自我价值的故事，她用汗水与泪水书写了属于自己的热辣人生。',
    category: 'drama',
    thumbnail: 'https://readdy.ai/api/search-image?query=Boxing%20gym%20movie%20scene%2C%20woman%20training%20with%20punching%20bag%2C%20sweat%20and%20determination%2C%20warm%20gym%20lighting%2C%20inspirational%20cinematic%20shot&width=800&height=450&seq=movie-drama-02&orientation=landscape',
    duration: '129分钟',
    quality: '1080P',
    views: 6700000,
    rating: 8.7,
    year: 2024,
    tags: ['剧情', '励志', '运动'],
    featured: false,
    isNew: false,
    content: '《热辣滚烫》讲述了乐莹从自卑的胖女孩蜕变为自信拳击手的故事。毕业后赋闲在家的乐莹在生活处处碰壁，直到她偶然走进一家拳击馆。在拳击中她找到了久违的力量感，开始了一段自我救赎和成长的旅程。',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐'],
  },
  {
    id: 'v009',
    title: '默杀',
    description: '一所女子中学内接连发生离奇命案，而每个人都可能是凶手，每个人也都是受害者。',
    category: 'horror',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dark%20school%20corridor%20at%20night%2C%20mysterious%20shadow%2C%20suspenseful%20horror%20atmosphere%2C%20dim%20reddish%20lighting%2C%20thriller%20film%20aesthetic%20with%20ominous%20tone&width=800&height=450&seq=movie-horror-01&orientation=landscape',
    duration: '112分钟',
    quality: '1080P',
    views: 3500000,
    rating: 8.1,
    year: 2024,
    tags: ['恐怖', '悬疑', '犯罪'],
    featured: false,
    isNew: false,
    content: '《默杀》是一部校园恐怖悬疑电影。一所女子中学内接连发生学生离奇死亡的案件，警方调查陷入僵局。每个看似普通的女学生都隐藏着不为人知的秘密。当沉默成为共谋，真相被层层掩埋，凶手究竟是谁？',
    director: '柯汶利',
    actors: ['张钧甯', '黄健玮', '王传君'],
  },
  {
    id: 'v010',
    title: '前任4：英年早婚',
    description: '孟云和余飞在即将步入婚姻殿堂时，面临了各种婚前焦虑和情感考验。',
    category: 'romance',
    thumbnail: 'https://readdy.ai/api/search-image?query=Romantic%20wedding%20scene%20in%20modern%20city%2C%20couple%20looking%20at%20each%20other%2C%20warm%20golden%20sunset%20light%2C%20soft%20cinematic%20romance%20film%20aesthetic&width=800&height=450&seq=movie-romance-01&orientation=landscape',
    duration: '128分钟',
    quality: '4K',
    views: 2900000,
    rating: 7.8,
    year: 2024,
    tags: ['爱情', '喜剧', '都市'],
    featured: false,
    isNew: false,
    content: '《前任4：英年早婚》延续了前任系列的故事。孟云和林佳和好之后准备步入婚姻，但筹备婚礼的过程远比他想象的要复杂。与此同时，余飞和丁点的感情也走到了十字路口。婚姻到底是爱情的坟墓还是新的开始？',
    director: '田羽生',
    actors: ['韩庚', '郑恺', '于文文'],
  },
  {
    id: 'v011',
    title: '志愿军：雄兵出击3',
    description: '抗美援朝战场上的最后一次大规模战役，中国志愿军用血肉之躯书写了可歌可泣的英雄史诗。',
    category: 'action',
    thumbnail: 'https://readdy.ai/api/search-image?query=Historical%20war%20battle%20scene%20in%20winter%20mountains%2C%20soldiers%20advancing%2C%20dramatic%20smoke%20and%20fire%2C%20warm%20cinematic%20lighting%20on%20battlefield&width=800&height=450&seq=movie-action-02&orientation=landscape',
    duration: '152分钟',
    quality: '4K',
    views: 5100000,
    rating: 9.1,
    year: 2025,
    tags: ['战争', '历史', '动作'],
    featured: false,
    isNew: true,
    content: '《志愿军：雄兵出击3》是志愿军系列的终章。影片聚焦于抗美援朝战争后期的重要战役，展现了中国人民志愿军在极其艰苦的条件下，以顽强意志和卓越战术最终赢得胜利的壮丽史诗。',
    director: '陈凯歌',
    actors: ['唐国强', '王砚辉', '刘劲'],
  },
  {
    id: 'v012',
    title: '深海',
    description: '一个少女坠入深海，在奇幻世界中展开了一段治愈心灵的冒险之旅。',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dreamy%20deep%20ocean%20animated%20scene%2C%20colorful%20jellyfish%20and%20sea%20creatures%2C%20magical%20underwater%20world%2C%20soft%20warm%20rays%20of%20light%2C%20artistic%20animation%20style&width=800&height=450&seq=movie-anime-03&orientation=landscape',
    duration: '115分钟',
    quality: '1080P',
    views: 1600000,
    rating: 8.9,
    year: 2024,
    tags: ['动画', '奇幻', '治愈'],
    featured: false,
    isNew: false,
    content: '《深海》是一部极具视觉冲击力的国产动画电影。小女孩参宿意外坠入深海，进入了一个光怪陆离的奇幻世界。在这个世界中她遇到了神秘的深海大饭店和一群有趣的伙伴，开启了一段探索自我、治愈心灵的旅程。',
    director: '田晓鹏',
    actors: ['苏鑫', '王亭文', '滕奎兴'],
  },
];